<hpo-content-layout [useAnchors]="!printState"
    [mobile]="mobile"
    [toolbarTemplate]="!printState ? detailsToolbar : null"
    (scrolling)="scrolling($event)">

    <div class="instruction"
        [class.instruction--mobile]="mobile">

        @if (instruction) {
            <div class="instruction-feedback__container">
                <span class="fake-link"
                    (click)="openFeedbackDialog()">
                    {{ 'default.openFeedbackDialog' | blah }}
                </span>
            </div>
            @if (printState !== 'item') {
                <h1 class="instruction__title">
                    {{instruction.attributes.name}}
                    <a routerLink="."
                        fragment="">
                        <mat-icon matTooltip="{{ 'default.copyLink' | blah }}"
                            matTooltipClass="hpo"
                            (click)="copyLink()">link</mat-icon>
                    </a>
                    <a (click)="openPrintDialog()">
                        <mat-icon>print</mat-icon>
                    </a>
                    <app-favorites [instruction]="instruction"></app-favorites>
                </h1>
            }
            @if (changelogEntries && changelogEntries.length > 0) {
                <a class="instruction__changelog"
                    (click)="showChangelog()">
                    {{ 'default.changelogInstruction' | blah }}
                </a>
            }
            <div class="instruction__details">
                <ul class="tags"
                    [ngClass]="{'tags-mobile': instruction.inIframe}">
                    @for (tag of instruction.tags; track tag) {
                        <li>
                            <a [routerLink]="['/catalog/headpower']"
                                [queryParams]="{ id: tag.attributes.drupal_internal__revision_id, name: tag.attributes.name }">
                                {{tag.attributes.name}}
                            </a>
                        </li>
                    }
                </ul>
                @if (instruction.inIframe && instruction.openedFrom !== 'IWS') {
                    <a class="add-instruction-to-iwm-btn"
                        [id]="'add-instruction-to-iwm-btn-' + instruction.id"
                        mat-stroked-button
                        color="primary"
                        (click)="addInstructionToIWM($event)">
                        <mat-icon inline=true>add</mat-icon>
                        {{ 'default.addInstructionToIwm' | blah }}
                    </a>
                }
            </div>
        }

        @if (loading) {
            <hpo-placeholder type="row"></hpo-placeholder>
            <hpo-placeholder type="row"></hpo-placeholder>
            <hpo-placeholder type="row"></hpo-placeholder>
        }

        <ng-template appHost></ng-template>

        <app-copyright></app-copyright>

    </div>

</hpo-content-layout>

<div class="print-note"
    [class.printing]="printState">

    @if (printState) {
        <h4>
            {{ 'default.printing' | blah }}...
        </h4>
    }

    @if (!printState) {
        <h4>
            {{ 'default.useInstructionPrintButton' | blah }}
        </h4>
    }

</div>

<ng-template #detailsToolbar>
    <div class="iwi-details-toolbar__container"
        [ngClass]="{'desktop': !mobile}">
        <div></div>
        <app-instruction-search [mobile]="mobile"></app-instruction-search>
    </div>
</ng-template>